module.exports = __webpack_public_path__ + "img/L0.51e40e1c.svg";